import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import envVars from '../../../constants/envVars';
import { blacklistedEmailsKey } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
const useAddEmailToSuppressionList = () => {
    const queryClient = useQueryClient();
    const params = useQueryRequestParams();
    return useMutation({
        mutationFn: (attributes) => axios.put(`${envVars.API_CLOUD_HOSTNAME}backoffice/user-email-blacklist/`, { ...attributes }, params),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [blacklistedEmailsKey] });
        }
    });
};
export default useAddEmailToSuppressionList;
